import { Navigate } from "react-router-dom";

// 🔐 ADMIN
export function ProtectedAdminRoute({ children }) {
  const isAdmin = localStorage.getItem("admin");

  if (!isAdmin) {
    return <Navigate to="/admin-login" />;
  }

  return children;
}



export  function ProtectedSuperAdminRoute({ children }) {
  const admin = JSON.parse(localStorage.getItem("admin"));

  if (!admin || admin.role !== "super_admin") {
    return <Navigate to="/admin-login" />;
  }

  return children;
}










// 👤 MEMBER
export function ProtectedMemberRoute({ children }) {
  const member = localStorage.getItem("member");

  if (!member) {
    return <Navigate to="/login" />;
  }

  return children;
}